import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { take } from 'rxjs/operators';
import { AccountService } from 'app/core';
import { Project, Property } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { FoldersTabService } from 'app/shared/modules/folders/folders.service';
import { PropertiesService } from 'app/modules/properties/properties.service';
import { Store } from '@ngxs/store';
import { Folders } from './state/actions';
import { CustomObjectActions } from '../custom-objects/state/actions';
import { RelatedToType } from 'app/shared/enums';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';

@Injectable({
  providedIn: 'root',
})
export class FolderTabResolver {
  constructor(
    private _projectsService: ProjectsService,
    private _propertiesService: PropertiesService,
    private _foldersTabService: FoldersTabService,
    private _accountService: AccountService,
    private _store: Store,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const folderIdMapping = {
      ['CUSTOM_OBJECTS']: route.params.customObjectValueId,
      ['DEALS']: route.params.project_id,
      ['PROPERTIES']: route.params.id,
      ['FOLDERS_TAB']: parseInt(route.paramMap.get('folderId')),
    };

    const folderId = folderIdMapping[route.data.module];
    let moduleName: string;
    let moduleId: number;

    this._foldersTabService.accountId = this._accountService.getCurrentAccount().id;

    if (Object.keys(route.params).filter((param) => ['relatedToKey', 'recordId'].includes(param))?.length) {
      const obj = this._store
        .selectSnapshot(ObjectsManagerState.get)
        .find((x) => x.uiConfig.urlPrefix === route.params.relatedToKey);
      moduleId = obj.id;
      moduleName = obj.name.includes('co_') ? RelatedToType.CustomObjectValue : obj.name;

      this.dispatchActions(moduleName, route.params.recordId, folderId);

      return;
    }

    if (/\/projects\//g.test(state.url)) {
      this._projectsService.project$.pipe(take(1)).subscribe((project: Project) => {
        moduleId = +project.id;
        moduleName = 'projects';
        this.dispatchActions(moduleName, moduleId, folderId);
      });
    } else if (/\/properties\//g.test(state.url)) {
      this._propertiesService.property$.pipe(take(1)).subscribe((property: Property) => {
        moduleId = property.id;
        moduleName = 'properties';
        this.dispatchActions(moduleName, moduleId, folderId);
      });
    } else if (/\/objects\//g.test(state.url)) {
      const filter = {
        id: route.params.customObjectValueId,
        customObjectId: route.params.customObjectId,
      };

      this._store
        .dispatch(new CustomObjectActions.GetValueById(filter))
        .pipe(take(1))
        .subscribe(() => {
          const customObjectValue = this._store.selectSnapshot((state) => state.customObjectState.selectedValue);
          moduleId = customObjectValue.id;
          moduleName = RelatedToType.CustomObjectValue;
          this.dispatchActions(moduleName, moduleId, folderId);
        });
    }
  }

  private dispatchActions(module: string, moduleId: number, folderId: number): void {
    this._store.dispatch([new Folders.UpdateFolderModule(module, moduleId), new Folders.GetFolder(folderId)]);
  }
}
